/**
 * Created by Ivan on 06/05/2017.
 */
export default {
    baseUrl : 'https://api.ceogrouphotel.com',
    /********************************************************************
     * Settings
     ********************************************************************/
    contact : {
        phone : '981-147-8076',
        email : 'recepcion@ceogrouphotel.com',
        address : 'San Francisco de Campeche, Campeche',
        address_small : 'Campeche',
        fax : '',
        webpage : location.origin
    },
    /********************************************************************
     * Language
     ********************************************************************/
    languages : [
        {
            id : 'es',
            name : 'spanish',
            icon : 'famfamfam-flag-es'
        },
        {
            id : 'en',
            name : 'english',
            icon : 'famfamfam-flag-gb'
        },
    ],
    /********************************************************************
     * Services
     ********************************************************************/
    services : [
        {
            id          : 1,
            src         : '/assets/ceo/restaurant.jpg',
            icon        : 'flaticon-food',
            title       : 'Comedor',
            subtitle    : 'Con desayuno continental incluído.',
            selected    : false
        },
        {
            id          : 2,
            src         : '/assets/ceo/habitacion.jpg',
            icon        : 'fa fa-bed',
            title       : 'Cómodas habitaciones',
            subtitle    : 'Nuestras habitaciones le harán sentir como en casa.',
            selected    : false
        },
        {
            id          : 3,
            src         : '/assets/ceo/sala_juntas.jpg',
            icon        : 'fa fa-briefcase',
            title       : 'Sala de juntas',
            subtitle    : 'El mejor lugar para sus juntas de trabajo.',
            selected    : false
        },
        {
            id          : 4,
            src         : '/assets/ceo/alberca.jpg',
            icon        : 'flaticon-beach',
            title       : 'Alberca',
            subtitle    : 'Hermosa y refrescante alberca al aire libre.',
            selected    : false
        },
        {
            id          : 5,
            src         : '/assets/ceo/gimnasio.jpg',
            icon        : 'fa fa-heartbeat',
            title       : 'Gimnasio',
            subtitle    : 'Acceso al gimnasio a todos nuestros huéspedes.',
            selected    : false
        },
    ],
    /********************************************************************
     * Testimonials
     ********************************************************************/
    testimonials : {
        limit : 5,
        order : 'id DESC'
    },
    /********************************************************************
     * Footer social settings
     ********************************************************************/
    social : {
        facebook : {
            href : '#',
            show : true,
            icon : 'fa-facebook',
            title : 'Facebook'
        },
        twitter  : {
            href : '#',
            show : true,
            icon : 'fa-twitter',
            title : 'Twitter'
        },
        googleplus : {
            href : '#',
            show : false,
            icon : 'fa-google-plus',
            title : 'Google Plus'
        },
        pinterest : {
            href : '#',
            show : false,
            icon : 'fa-pinterest',
            title : 'Pinterest'
        },
        linkedin : {
            href : '#',
            show : true,
            icon : 'fa-linkedin',
            title : 'Linkedin'
        },
        instagram : {
            href : '#',
            show : true,
            icon : 'fa-instagram',
            title : 'Instagram'
        },
        youtube : {
            href : '#',
            show : true,
            icon : 'fa-youtube',
            title : 'Youtube'
        },
    },
    /********************************************************************
     * Services
     ********************************************************************/
    coordenate: {
        lat: 19.3911668,
        lng: -99.4238178
    }
};


// WEBPACK FOOTER //
// ./src/config/app.js